import { milestones } from "../data/program";
import type { GroupProfile, VideoEntry } from "../types/hackathon";
import { PROGRAM_DAYS } from "./dates";

export function groupProgress(group: GroupProfile | undefined, videos: VideoEntry[], groupId: number) {
  const milestonesDone = group ? milestones.filter((m) => group.milestones[m.id]).length : 0;
  const videosDone = videos.filter((v) => v.groupId === groupId).length;
  const percent = Math.round(((milestonesDone / milestones.length + videosDone / PROGRAM_DAYS) / 2) * 100);
  return {
    milestonesDone,
    milestonesTotal: milestones.length,
    videosDone,
    videosTotal: PROGRAM_DAYS,
    percent,
  };
}

export function initials(name: string): string {
  const words = name.split(/\s+/).filter((w) => /^[A-Za-zÀ-ÿ]/.test(w));
  if (words.length === 0) return "";
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return (first + last).toUpperCase();
}
